import { render, staticRenderFns } from "./ERquery.vue?vue&type=template&id=504969a8&scoped=true"
import script from "./ERquery.vue?vue&type=script&lang=js"
export * from "./ERquery.vue?vue&type=script&lang=js"
import style0 from "./ERquery.vue?vue&type=style&index=0&id=504969a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504969a8",
  null
  
)

export default component.exports